export default __webpack_public_path__ + "static/media/smsplan.b5c9bc38.svg";